import React from 'react';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { ReviewEventCard } from './ReviewEventCard';
import styles from './reviewEvents.module.scss';

export const EventReviewSection = ({ titleId, titleDefaultMessage, events, onEditEvent, onSetFocusedConversionId }) => {
    if (!events || events.length === 0) {
        return null;
    }

    return (
        <div className={styles['section-container']}>
            <div className={styles['header-subtitle']}>
                <FormattedMessage id={titleId} defaultMessage={titleDefaultMessage} />
            </div>
            <div className={styles['review-cards-container']}>
                {events.map(event => (
                    <ReviewEventCard
                        event={event}
                        key={event.id}
                        onEdit={onEditEvent}
                        setFocusedConversionId={onSetFocusedConversionId}
                    />
                ))}
            </div>
        </div>
    );
};
